export default __webpack_public_path__ + "static/media/lieferheld_grid_xl.8c526bc1.jpg";